import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren  } from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-adjust-cells-value',
    templateUrl: './adjust-cells-value.component.html',
    styleUrls: ['./adjust-cells-value.component.css']
})
export class AdjustCellsValueComponent implements OnInit, AfterViewInit {
    @ViewChildren('input') vc;
    cellValue: number = null;

    constructor(private translate: TranslateService) { }

    @Input() x = 0;
    @Input() y = 0;
    @Output() adjustValueCloseEvent = new EventEmitter<string>();
    @Output() adjustValueEvent = new EventEmitter<number>();

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => { this.vc.first.nativeElement.focus() });
    }

    closeClicked() {
        this.adjustValueCloseEvent.emit('Close');
    }

    adjustClicked() {
        this.adjustValueEvent.emit(this.cellValue);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/adjust-cells-value/adjust-cells-value.component.ts